import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetProductsByOrganizationIdQueryVariables = Types.Exact<{
  organization_id: Types.Scalars['uuid']['input'];
}>;


export type GetProductsByOrganizationIdQuery = { __typename?: 'query_root', products: Array<{ __typename?: 'products', id: any, name: string, description: string, sku?: string | null, make: string, model: string, retail_price?: any | null, extended_price?: any | null, product_notes?: string | null, created_at?: any | null, updated_at?: any | null, workspace_id?: any | null, organization_id?: any | null, photo_link?: string | null, partition_id?: string | null, product_category: { __typename?: 'product_categories', name: string, label: string }, product_attachments: Array<{ __typename?: 'product_attachments', id: any, product_id: any, photo_link?: string | null, document_link?: string | null, video_link?: string | null, audio_link?: string | null, site_link?: string | null, transcription?: string | null, transcribed: boolean, type?: string | null, name?: string | null, description?: string | null, created_at: any, updated_at: any }>, organization?: { __typename?: 'organizations', id: any, name: string, email?: string | null, organizationImageURL?: string | null, contact_name?: string | null, type?: string | null } | null }> };


export const GetProductsByOrganizationIdDocument = gql`
    query getProductsByOrganizationId($organization_id: uuid!) {
  products(
    where: {organization_id: {_eq: $organization_id}, deleted_at: {_is_null: true}}
    order_by: {name: asc}
  ) {
    id
    name
    description
    sku
    product_category {
      name
      label
    }
    make
    model
    retail_price
    extended_price
    product_notes
    created_at
    updated_at
    workspace_id
    organization_id
    photo_link
    partition_id
    product_attachments {
      id
      product_id
      photo_link
      document_link
      video_link
      audio_link
      site_link
      transcription
      transcribed
      type
      name
      description
      created_at
      updated_at
    }
    organization {
      id
      name
      email
      organizationImageURL
      contact_name
      type
    }
  }
}
    `;

/**
 * __useGetProductsByOrganizationIdQuery__
 *
 * To run a query within a React component, call `useGetProductsByOrganizationIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsByOrganizationIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsByOrganizationIdQuery({
 *   variables: {
 *      organization_id: // value for 'organization_id'
 *   },
 * });
 */
export function useGetProductsByOrganizationIdQuery(baseOptions: Apollo.QueryHookOptions<GetProductsByOrganizationIdQuery, GetProductsByOrganizationIdQueryVariables> & ({ variables: GetProductsByOrganizationIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsByOrganizationIdQuery, GetProductsByOrganizationIdQueryVariables>(GetProductsByOrganizationIdDocument, options);
      }
export function useGetProductsByOrganizationIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsByOrganizationIdQuery, GetProductsByOrganizationIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsByOrganizationIdQuery, GetProductsByOrganizationIdQueryVariables>(GetProductsByOrganizationIdDocument, options);
        }
export function useGetProductsByOrganizationIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductsByOrganizationIdQuery, GetProductsByOrganizationIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductsByOrganizationIdQuery, GetProductsByOrganizationIdQueryVariables>(GetProductsByOrganizationIdDocument, options);
        }
export type GetProductsByOrganizationIdQueryHookResult = ReturnType<typeof useGetProductsByOrganizationIdQuery>;
export type GetProductsByOrganizationIdLazyQueryHookResult = ReturnType<typeof useGetProductsByOrganizationIdLazyQuery>;
export type GetProductsByOrganizationIdSuspenseQueryHookResult = ReturnType<typeof useGetProductsByOrganizationIdSuspenseQuery>;
export type GetProductsByOrganizationIdQueryResult = Apollo.QueryResult<GetProductsByOrganizationIdQuery, GetProductsByOrganizationIdQueryVariables>;